//130354281703477990271604258750
theme.library = 130354281703477990271604258750;
theme.crr_library = localStorage.getItem('library') || '[]';
theme.psjson_lib = new Array;
theme.strings = {
  inStock: "translation missing: fr.products.product.in_stock",
  outOfStock: "translation missing: fr.products.product.out_of_stock",
  soldOut: "translation missing: fr.products.product.sold_out",
  qtyLabel: "translation missing: fr.products.product.quantity",
  addToCart: "translation missing: fr.products.product.add_to_cart",
  addedToCart: "translation missing: fr.products.product.added_to_cart",
  contact: "translation missing: fr.products.product.contact",
  remove: "translation missing: fr.cart.general.remove",
  empty: "translation missing: fr.cart.general.empty",
  cartItem: "translation missing: fr.cart.general.items_with_count_html",
  cartItems: "translation missing: fr.cart.general.items_with_count_html",
  cartItemText: "translation missing: fr.layout.cart.items_count",
  cartItemsText: "translation missing: fr.layout.cart.items_count",
  noimage: "\/\/cdn.shopify.com\/s\/files\/1\/0426\/9096\/9758\/t\/11\/assets\/noimage.gif?6467",
  cdday: "translation missing: fr.general.countdown.count_down_day",
  cdhrs: "translation missing: fr.general.countdown.count_down_hours",
  cdmin: "translation missing: fr.general.countdown.count_down_minute",
  cdsecs: "translation missing: fr.general.countdown.count_down_seconds",
  nll_error_mesenger: "translation missing: fr.general.newsletter_form.error_mesenger",
  nll_success_mesenger: "translation missing: fr.general.newsletter_form.success_mesenger_html",
  aspect_ratio: "1/1",
  search_dropdown_pages: "translation missing: fr.general.search_dropdown.pages_group",
  search_dropdown_articles: "translation missing: fr.general.search_dropdown.articles_group",
  search_dropdown_no_results: "translation missing: fr.general.search_dropdown.no_results",
  flt_range: "translation missing: fr.collections.filters.slider_range"
};
theme.productStrings = {
  sizeGuide: "translation missing: fr.products.product.size_chart",
  addToCart: "translation missing: fr.products.product.add_to_cart",
  preOrder: "translation missing: fr.products.product.pre_order",
  selectOption: "translation missing: fr.products.product.select_option",
  soldOut: "translation missing: fr.products.product.sold_out",
  inStock: "translation missing: fr.products.product.in_stock",
  outOfStock: "translation missing: fr.products.product.out_of_stock",
  unavailable: "translation missing: fr.products.product.unavailable",
  onlyLeft: "translation missing: fr.products.product.only_left_short_text_html",
  onSale: "translation missing: fr.general.search_dropdown.sale_label",
  stockMessage: ["Hurry! Only "," left in stock."],
  label_select: "translation missing: fr.products.product.label_select",
  viewMoreVariants: "translation missing: fr.products.product.view_more_variants",
  addToWishlist: "translation missing: fr.products.wishlist.add_to_wishlist",
  viewWishlist: "translation missing: fr.products.wishlist.view_wishlist"
};
theme.function = {
  multiCurrency: true,
  typeCurrency: "shopify",
  autoCurrency: false,
  searchAjax: true,
  searchByCollection: true,
  searchAjaxTypes: "product",
  vrsgallery: true,
  quickshop: "true",
  quickview: true,
  use_thumb_hidden_on_mb: false,
  productImgType: "normal",
  productOptionStyle: [{'name': "Color",'style': "not_select square",'color_watched': true,'op_attach': false,'op_pre_select': false},{'name': "Size",'style': "combobox",'color_watched': false,'op_attach': true,'op_pre_select': false},{'name': "Style",'style': "combobox with_out_variant_image",'color_watched': false,'op_attach': false,'op_pre_select': false},{'name': "Model",'style': "combobox with_out_variant_image",'color_watched': false,'op_attach': false,'op_pre_select': false},{'name': "",'style': "not_select circle",'color_watched': false,'op_attach': false,'op_pre_select': false}],
  productGridOptionStyle: [{'name': "Color",'style': "circle _small",'color_watched': true, 'sw_style': "color"},{'name': "Size",'style': "square _small",'color_watched': false, 'sw_style': "color"},{'name': "Material",'style': "list list_1",'color_watched': false, 'sw_style': "color"},{'name': "Model",'style': "square",'color_watched': true, 'sw_style': "color"},{'name': "",'style': "list list_1",'color_watched': false, 'sw_style': "color"}],
  photoZoom: true,
  nll_ajax: true,
  type_ajax_cart: "drawer",
  ajax_cart_page: true,
  sticky_icon_cart: null,
  textInListShipping: "translation missing: fr.products.delivery.text_in_list",
  textInListShippingMax: "translation missing: fr.products.delivery.text_in_list_max",
  product_delivery: {
    offSaturday: true,
    offSunday: true,
    offDays: ["23\/12\/****","24\/12\/****","01\/01\/****","02\/11\/2019"],
    fromDate: 10,
    toDate: 19 
  },
  countdown_timezone: false,
  timezone: 'Etc/GMT-4',
  variantsLoad: false
};
theme.compare = {
  remove: "translation missing: fr.products.compare.remove"
};
theme.gadget = {
  cookies_infor: true,
  newsletter_popup: false,
  shipTo: false
};
theme.suggest = {
  enable: false, 
  collection_opj: null,
  delay_time: 15000,
  show_time: 7600,
  use_fake_location: true,
  arr_fake_location: ["Melbourne, Australia","Washington","Nevada"]
};

theme.extensions = {
  ktjs_product_sg: '//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/ktjs_product_sg.min.js?v=36205597685854357351604258734',
  ktjs_flts_or: false
}

const firstLink = document.getElementsByTagName("link")[0];
const headDocument = document.head;
const bodyDocument = document.body;

if (theme.crr_library.length == 0) {
  localStorage.setItem('library','[]');
}

window._handleize = function(str){
  str = (str+'').toLowerCase();
  return str=str.replace(/'|"|\(|\)|\[|\]/g,"").replace(/[\s\x21-\x2f\x3a-\x40\x7b-\x7f^`\\[\]]+/g,"-").replace(/\W+/g,"-").replace(/^-+|-+$/g,"")
}
window._snakeCase = function(str){
  str = (str+'').toLowerCase();
  return str=str.replace(/'|"|\(|\)|\[|\]/g,"").replace(/[\s\x21-\x2f\x3a-\x40\x7b-\x7f^`\\[\]]+/g,"_").replace(/\W+/g,"_").replace(/^-+|-+$/g,"")
}
$.getScriptCached = function(url, callback) {return $.ajax({url: url,dataType: "script",cache: true}).done(callback)};
"undefined" == typeof KT && (KT = {});
KT.checkVersion = function(name_item){
  name_item = name_item.split('/')[name_item.split('/').length - 1];
  var version = false;
  if(!localStorage.getItem(name_item)){
    version = true; 
  }
  var libs_ver = JSON.parse(theme.crr_library);
  if (libs_ver.length && libs_ver.findIndex(function(obj){ return obj.name == name_item}) !== -1) { 
    var objIndex = libs_ver.findIndex(function(obj){ return obj.name == name_item});
    if (parseFloat(libs_ver[objIndex].ver) !== theme.library) {
      libs_ver[objIndex].ver = theme.library;
      localStorage.setItem('library',JSON.stringify(libs_ver));
      version = true;
    }
  } else if(libs_ver.findIndex(function(obj){ return obj.name == name_item}) === -1){
    version = true;
  }
  return version; 
}
KT.pushVersion = function(name_item){
  var libs_ver = JSON.parse(theme.crr_library);
  if (libs_ver.length && libs_ver.findIndex(function(obj){ return obj.name == name_item}) !== -1) { 
    var objIndex = libs_ver.findIndex(function(obj){ return obj.name == name_item});
    if (parseFloat(libs_ver[objIndex].ver) !== theme.library) {
      libs_ver[objIndex].ver = theme.library;
      localStorage.setItem('library',JSON.stringify(libs_ver));
    }
  }
  else {
    var obj = {
      name : name_item,
      ver : theme.library
    }
    libs_ver.push(obj);
    localStorage.setItem('library',JSON.stringify(libs_ver));
  }
  theme.crr_library = localStorage.getItem('library') || '[]';
}
KT.loadScript = function(id, callback) {
  let css_url = "";
  let js_url = "";
  let done = false;
  if($('#'+id).length || $('#'+id).length){
    checkExists(id, js_url)
  }
  else {
    if(id == 'magnific-popup' && $('#magnific-popup-css').length <= 0){
      css_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/magnific-popup.min.css?v=57525974320827922071604258735";
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/jquery.magnific-popup.min.js?v=184369421263510081681604258730";
    }
    else if(id == 'threesixty' && $('#threesixty-css').length <= 0){
      css_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/threesixty.min.css?v=87491138002852594671604258751";
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/threesixty.min.js?v=128470061555666291351604258751";
    }
    else if(id == 'photo-swipe' && $('#photo-swipe-css').length <= 0){
      css_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/photoswipe-ui.min.css?v=50182594455179234001604258740";
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/photoswipe-ui.min.js?v=89145670203526742621604258740";
    }
    else if(id == 'YTPlayer'){
      css_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/jquery.mb.YTPlayer.min.css?v=119550751124163094881604258730";
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/jquery.mb.YTPlayer.min.js?v=141316012292176472591604258730";
    }
    else if(id == 'swiper'){ 
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/swiper.min.js?v=119301780810473861691604258745";
    }
    else if(id == 'pjax'){
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/jquery.pjax.min.js?v=96510263879411166301604258731";
    }
    else if(id == 'imagesloaded'){
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/imagesloaded.pkgd.min.js?v=147859183389955144291604258724";
    }
    else if(id == 'isotope'){
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/isotope-plus.pkgd.min.js?v=139088845446234680461604258725";
    }
    else if(id == 'instafeed'){
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/instafeed.min.js?v=167375059766121062631604258725";
    }
    else if(id == 'countdown'){
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/jquery.countdown.min.js?v=116994322243221080931604258727";
    }
    else if(id == 'countto'){
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/jquery.countTo.min.js?v=148382760188409556611604258727";
    }
    else if(id == 'moment'){
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/moment.min.js?v=96302747854271246571604258737";
    }
    else if(id == 'moment-zone'){
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/moment-timezone-with-data.min.js?v=28936048893783064501604258737";
    }
    else if(id == 'momentlocale'){
      if (shopLocale === 'en') {handleLoad(); return}
      js_url = "//cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/locale/"+shopLocale+".js";
    }
    else if(id == 'zoom'){
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/jquery.zoom.min.js?v=127655014540499679121604258731";
    }
    else if(id == 'parallax'){
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/jquery.parallax_mousemove.js?v=79184343061227765141604258730";
    }
    else if(id == 'tippy'){
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/tippy-bundle.iife.min.js?v=119878756178377760041604258752";
    }
    else if(id == 'color_sw'){
      css_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/swatch-color.css?v=87112208204652398511604258744";
    }
    else if(id == 'animate'){
      css_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/animate.min.css?v=20349278028107590831604258719";
    }
    else if(id == 'molla_icon'){
      css_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/molla-icon.css?v=68882120459035398511604258735";
    }
    else if(id == 'molla_font'){
      css_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/theme.font.css?v=57933660763464881701608165161";
    }
    else if(id == 'google_f'){
      css_url = theme.link_google_f;
    }
    else if(id == 'adminThemeCss'){
      css_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/adminThemeTool.scss.css?6467";
    }
    else if(id == 'shopify-currency'){
      js_url = "//cdn.shopify.com/s/javascripts/currencies.js";
    }
    else if(id == 'shipping'){
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/jquery.currency-shipping.min.js?v=77586439398839307371604258728";
    }
    else if(id == 'plyr'){
      css_url = "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.1/shopify-plyr.css";
      js_url = "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.en.js";
    }
    else if(id == 'shopify-xr'){
      js_url = "//cdn.shopify.com/shopifycloud/shopify-xr-js/v1.0/shopify-xr.en.js";
    }
    else if(id == 'model-viewer-ui'){
      css_url = "//cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css";
      js_url = "//cdn.shopify.com/shopifycloud/model-viewer-ui/v1.0/model-viewer-ui.en.js";
    }
    else if(id == 'theme-alert'){
      js_url = "//cdn.shopify.com/s/files/1/0426/9096/9758/t/11/assets/theme-alert.js?v=28077311757223122841604258814";
    }
    done = false;
    ajaxLoad(id, css_url, js_url);
  }
  function ajaxLoad(name, css_url, js_url){
    if(css_url !== ''){
      var scr_css = document.createElement('link');
      scr_css.type = 'text/css';
      scr_css.rel = "stylesheet";
      scr_css.cache = true;
      scr_css.id = name+'-css';
      scr_css.href = css_url;
      scr_css.onerror = function() {
        alert("Error loading css " + this.href);
      };
      headDocument.insertBefore(scr_css, firstLink);
    }
    if(js_url !== ''){
      var scr_js = document.createElement('script');
      scr_js.type = 'text/javascript';
      scr_js.cache = true;
      scr_js.async = true;
      scr_js.src = js_url;
      scr_js.id = name;
      scr_js.onload = checkExists(name, js_url);
      scr_js.onerror = function() {
        alert("Error loading js " + this.src);
      };
      bodyDocument.appendChild(scr_js);
    }
  }
  function checkExists(id, js_url){
    var callbackTimer = setInterval(function() {
      if (id == 'swiper' && typeof Swiper === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'owl-carousel' && typeof $.fn.owlCarousel === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'slick-slide' && typeof $.fn.slick === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'moment' && typeof moment === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'moment-zone' && typeof moment.tz === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }      
      if (id == 'magnific-popup' && typeof $.fn.magnificPopup === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'imagesloaded' && typeof $.fn.imagesLoaded === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'isotope' && typeof $.fn.isotope === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'YTPlayer' && typeof jQuery.fn.YTPlayer === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'parallax' && typeof $.fn.mouseMove === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'countdown' && typeof $.fn.countdown === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'countto' && typeof $.fn.countTo === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'magnific-popup' && typeof $.fn.magnificPopup == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'instafeed' && typeof Instafeed == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'momentlocale' && moment.locale() == shopLocale){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'zoom' && typeof $.fn.zoom == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'pjax' && typeof $.fn.pjax == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'photo-swipe' && typeof PhotoSwipe == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'threesixty' && typeof $.fn.ThreeSixty == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'tippy' && typeof tippy == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'shipping' && typeof Kt_currency.convertAll == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'shopify-currency' && typeof Currency !== "undefined") {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'plyr' && typeof Shopify.Plyr == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'shopify-xr' && typeof ShopifyXR !== 'undefined') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'model-viewer-ui' && typeof Shopify.ModelViewerUI == 'function' ) {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'theme-alert' && typeof KT_Alert !== "undefined" ) {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
    }, 100);
  }
  function handleLoad() {
    if (!done) {
      done = true;
      // console.log(js_url)
      callback(js_url, "ok");
    }
  }
}